import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const UbisoftConnectGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/Ubisoft_Connect2.png`}
          alt="Ubisoft Connect"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product key activation on Uplay/Ubisoft Connect</h1>
          <p>Activate your Ubisoft Connect keys through the Uplay application</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        <div className={styles.steps}>
          
          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Download Uplay</h3>
              <div className={styles.stepDescription}>
                In order to activate your Uplay Code, visit{' '}
                <a 
                  href="https://uplay.ubi.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.inlineLink}
                >
                  Uplay
                </a>
                {' '}and download Uplay for PC.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/ubisoft-step-1.png`}
                  alt="Step 1: Download Uplay for PC"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Sign In and Access Menu</h3>
              <div className={styles.stepDescription}>
                After you launch the app, Sign in to your Uplay account or create a new one. Once you sign in/register, click on the <strong className={styles.boldText}>Menu</strong> and select <strong className={styles.boldText}>'Activate a key'</strong>.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/ubisoft-step-2.png`}
                  alt="Step 2: Click Menu and select Activate a key"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Activate Your Key</h3>
              <div className={styles.stepDescription}>
                Activation window will pop up. All you need to do is paste your Game Key in the designated area and click the <strong className={styles.boldText}>'Activate'</strong> button.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/ubisoft-step-3.png`}
                  alt="Step 3: Paste Game Key and click Activate"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>Ubisoft Connect codes are region-specific and must match your account region</li>
          <li>Some games may require additional setup after activation</li>
          <li>Codes can only be used once and cannot be transferred between accounts</li>
          <li>Make sure you have sufficient storage space for the game download</li>
        </ul>
      </div>

      <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://www.ubisoft.com/en-us/help/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            Ubisoft Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default UbisoftConnectGuide; 